import { ref } from 'vue'

/** @type {import('vue').Ref<null | { url: string }>} */
export const checkoutOpenFallbackState = ref(null)

/** 弹窗被拦截时展示「点击打开收银台」链接（用户二次点击可绕过拦截）。 */
export function showCheckoutOpenFallback(url) {
  if (import.meta.server) return
  const href = String(url || '').trim()
  if (!href) return
  checkoutOpenFallbackState.value = { url: href }
}

export function dismissCheckoutOpenFallback() {
  checkoutOpenFallbackState.value = null
}
